<template>
  <div v-loading="loading">
    <div class="row">
      <div class="col-6 col-md-4 mb-4" v-for="snap in snaps" :key="snap.id">
        <div class="card shadow h-100">
          <a :href="`https://www.nyonyacooking.com/snaps/${ snap.id }`" target="_blank">
            <img class="rounded-top" width="100%" :src="`https://ucarecdn.com/${ snap.image_id }/-/scale_crop/300x300/center/-/quality/lighter/`">
          </a>
          <div class="card-body">
            <a v-if="snap.recipe" :href="`https://www.nyonyacooking.com/recipes/${ snap.recipe.slug }~${ snap.recipe.id }`" target="_blank">
              <p class="badge badge-pill badge-secondary">{{ snap.recipe.title }}</p>
            </a>
            <small>
              <p>
                <router-link :to="{ name: 'users-id', params: { id: snap.user.id }}">
                  {{ snap.user.name }}
                </router-link>:
                {{ snap.desc }}
              </p>
            </small>
            <snap-delete :snapId="snap.id" @delete="getSnaps" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SnapDelete from '@/components/Snap/SnapDelete'

export default {
  data() {
    return {
      loading: true,
      snaps: [],
    }
  },
  components: {
    SnapDelete,
  },
  mounted() {
    this.getSnaps()
  },
  methods: {
    getCreatedDate(timestamp) {
      return moment(timestamp).fromNow()
    },
    onClick() {
      window.location.href = `${ process.env.VUE_APP_APP_HOST }/recipes`
    },
    async getSnaps() {
      this.loading = true
      try {
        var { data } = await this.$http.get(`/snaps`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.snaps = data
    },
  },
}
</script>

<style scoped>
.el-col {
  margin-bottom: 15px;
}

.time {
  font-size: 13px;
  color: #999;
}

.image {
  width: 100%;
  display: block;
}
</style>
